<div #popupReference class="container">

  <button class="icon-button" (click)="onTogglePlay()">
    @if (reallyPlaying$ | async) {
      <tun-pause-icon-v5 class="icon {{colorString$ | async}}"></tun-pause-icon-v5>
    }
    @if (!(reallyPlaying$ | async)) {
      <tun-play-icon-v5 class="icon {{colorString$ | async}}"></tun-play-icon-v5>
    }
  </button>

  <tun-round-progress-view class="progress"></tun-round-progress-view>

</div>

